import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
export default defineMessages({
  'license.activatedAt': {
    id: 'license.props.activatedAt.label',
    description: 'Label for license prop activation date',
    defaultMessage: 'Activated',
  },
  'licenseLog.activatedAt': {
    id: 'license.props.activatedAt.label',
    description: 'Label for license prop activation date',
    defaultMessage: 'Activated',
  },
  'retailer.id': {
    id: 'license.props.retailer.id.label',
    description: 'Label for license prop retailer (id)',
    defaultMessage: 'Retailer (id)',
  },
  'retailer.name': {
    id: 'license.props.retailer.name.label',
    description: 'Label for license prop retailer name',
    defaultMessage: 'Retailer',
  },
  'seller.id': {
    id: 'license.props.seller.id.label',
    description: 'Label for license prop seller (id)',
    defaultMessage: 'Seller (id)',
  },
  'seller.username': {
    id: 'license.props.seller.username.label',
    description: 'Label for license prop seller (username)',
    defaultMessage: 'Seller',
  },
  'seller.email': {
    id: 'license.props.seller.email.label',
    description: 'Label for license prop seller (email)',
    defaultMessage: 'Seller',
  },
  'company.businessId': {
    id: 'license.props.company.businessId.label',
    description: 'Label for license prop company business id',
    defaultMessage: 'Business id',
  },
  'company.name': {
    id: 'license.props.company.name.label',
    description: 'Label for license prop company name',
    defaultMessage: 'Company',
  },
  'company.website': {
    id: 'license.props.company.website.label',
    description: 'Label for license prop company website',
    defaultMessage: 'Website',
  },
  'company.contact': {
    id: 'license.props.company.contact.label',
    description: 'Label for license prop company contact',
    defaultMessage: 'Company contact',
  },
  'company.phone': {
    id: 'license.props.company.phone.label',
    description: 'Label for license prop phone',
    defaultMessage: 'Phone',
  },
  'company.email': {
    id: 'license.props.company.email.label',
    description: 'Label for license prop email',
    defaultMessage: 'Email',
  },
  'license.company.businessId': {
    id: 'license.props.company.businessId.label',
    description: 'Label for license prop company business id',
    defaultMessage: 'Business id',
  },
  'license.company.name': {
    id: 'license.props.company.name.label',
    description: 'Label for license prop company name',
    defaultMessage: 'Company',
  },
  'license.company.contact': {
    id: 'license.props.company.contact.label',
    description: 'Label for license prop company contact',
    defaultMessage: 'Company contact',
  },
  'license.company.phone': {
    id: 'license.props.company.phone.label',
    description: 'Label for license prop phone',
    defaultMessage: 'Phone',
  },
  'license.company.email': {
    id: 'license.props.company.email.label',
    description: 'Label for license prop email',
    defaultMessage: 'Email',
  },
  'license.continuous': {
    id: 'license.props.continuous.label',
    description: 'Label for license prop continuous',
    defaultMessage: 'Automatic renewal',
  },
  'licenseType.name': {
    id: 'license.props.licenseType.name.label',
    description: 'Label for license prop license name',
    defaultMessage: 'License',
  },
  'license.licenseType.name': {
    id: 'license.props.licenseType.name.label',
    description: 'Label for license prop license name',
    defaultMessage: 'License',
  },
  'licenseType.rrpNoVat': {
    id: 'license.props.licenseType.rrpNoVat.label',
    description: 'Label for license prop license RRP VAT not incl.',
    defaultMessage: 'RRP VAT not incl.',
  },
  'license.licenseType.rrpNoVat': {
    id: 'license.props.licenseType.rrpNoVat.label',
    description: 'Label for license prop license RRP VAT not incl.',
    defaultMessage: 'RRP VAT not incl.',
  },
  'license.startDate': {
    id: 'license.props.startDate.label',
    description: 'Label for license prop start date',
    defaultMessage: 'Start date',
  },
  'licenseLog.startDate': {
    id: 'license.props.startDate.label',
    description: 'Label for license prop start date',
    defaultMessage: 'Start date',
  },
  'license.endDate': {
    id: 'license.props.endDate.label',
    description: 'Label for license prop end date',
    defaultMessage: 'End date',
  },
  'license.endDateWithExtra': {
    id: 'license.props.endDateWithExtra.label',
    description: 'Label for license prop end date with extra months',
    defaultMessage: 'End date with extra months',
  },
  'licenseLog.endDate': {
    id: 'license.props.endDate.label',
    description: 'Label for license prop end date',
    defaultMessage: 'End date',
  },
  'license.extraMonths': {
    id: 'license.props.extraMonths.label',
    description: 'Label for license prop extra months',
    defaultMessage: 'Extra months',
  },
  'licenseLog.billedAt': {
    id: 'license.props.billedAt.label',
    description: 'Label for license prop billed at',
    defaultMessage: 'Billed at',
  },
  'licenseLog.paidAt': {
    id: 'license.props.paidAt.label',
    description: 'Label for license prop paid at',
    defaultMessage: 'Paid at',
  },
  'license.customerReference': {
    id: 'license.props.customerReference.label',
    description: 'Label for license prop reference number',
    defaultMessage: 'Customer reference',
  },
  'licenseLog.customerReference': {
    id: 'license.props.customerReference.label',
    description: 'Label for license prop reference number',
    defaultMessage: 'Customer reference',
  },
  'licenseType.periodInMonths': {
    id: 'license.props.licenseType.periodInMonths.label',
    description: 'Label for license prop period in months',
    defaultMessage: 'Period (months)',
  },
  'license.licenseType.periodInMonths': {
    id: 'license.props.licenseType.periodInMonths.label',
    description: 'Label for license prop period in months',
    defaultMessage: 'Period (months)',
  },
  'license.status': {
    id: 'license.props.status.label',
    description: 'Label for license prop status',
    defaultMessage: 'Status',
  },
  'licenseLog.status': {
    id: 'license.props.status.label',
    description: 'Label for license prop status',
    defaultMessage: 'Status',
  },
  'licenseLog.priceNoVat': {
    id: 'license.props.priceNoVat.label',
    description: 'Label for license prop price VAT not incl.',
    defaultMessage: 'Price (euros) VAT not incl.',
  },
  'license.priceNoVat': {
    id: 'license.props.priceNoVat.label',
    description: 'Label for license prop price VAT not incl.',
    defaultMessage: 'Price (euros) VAT not incl.',
  },
  'license.deactivatedAt': {
    id: 'license.props.deactivatedAt.label',
    description: 'Label for license prop deactivation',
    defaultMessage: 'Deactivated',
  },
  'deactivatedBy.id': {
    id: 'license.props.deactivatedBy.id.label',
    description: 'Label for license prop deactivated by (id)',
    defaultMessage: 'Deactivated by (id)',
  },
  'deactivatedBy.username': {
    id: 'license.props.deactivatedBy.username.label',
    description: 'Label for license prop deactivated by',
    defaultMessage: 'Deactivated by',
  },
  'contactPerson.firstName': {
    id: 'contactPerson.props.firstName.label',
    description: 'Label for contact person prop first name',
    defaultMessage: 'Contact person first name',
  },
  'contactPerson.lastName': {
    id: 'contactPerson.props.lastName.label',
    description: 'Label for contact person prop last name',
    defaultMessage: 'Contact person last name',
  },
  'contactPerson.name': {
    id: 'contactPerson.props.name.label',
    description: 'Label for contact person prop name',
    defaultMessage: 'Contact person',
  },
  'contactPerson.email': {
    id: 'contactPerson.props.email.label',
    description: 'Label for contact person prop email',
    defaultMessage: 'Contact person email',
  },
  'contactPerson.phone': {
    id: 'contactPerson.props.phone.label',
    description: 'Label for contact person prop phone',
    defaultMessage: 'Contact person phone',
  },
  'license.createdAt': {
    id: 'license.props.createdAt.label',
    description: 'Label for license prop created at',
    defaultMessage: 'Created at',
  },
  'licenseLog.createdAt': {
    id: 'license.props.createdAt.label',
    description: 'Label for license prop created at',
    defaultMessage: 'Created at',
  },
  'createdBy.id': {
    id: 'license.props.createdBy.id.label',
    description: 'Label for license prop created by (id)',
    defaultMessage: 'Created by (id)',
  },
  'createdBy.username': {
    id: 'license.props.createdBy.username.label',
    description: 'Label for license prop created by',
    defaultMessage: 'Created by',
  },
});
